import { render, staticRenderFns } from "./EducatorCreate.vue?vue&type=template&id=430c581a&"
import script from "./EducatorCreate.vue?vue&type=script&lang=js&"
export * from "./EducatorCreate.vue?vue&type=script&lang=js&"
import style0 from "./EducatorCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports